// Deterministic display color for a followed community's attribution dot on a FeedCard
// (GROWTH-7129). GET /api-v2/feed has no color field for a community, and there is no color
// anywhere else in the community data the dashboard already loads — this hashes community_id
// into a fixed palette instead, so the same community always renders the same color, and the
// same function is available for GROWTH-7130's sidebar dots to stay consistent with this one.
const PALETTE = [
  "var(--color-blue-400)",
  "var(--color-green-400)",
  "var(--color-purple-500)",
  "var(--color-amber-400)",
  "var(--color-red-300)",
  "var(--color-blue-700)"
];

/**
 * @param {number|string} communityId hlm_heritage.heritage_id
 * @returns {string} a CSS color value (one of the design token vars above)
 */
export const communityColor = communityId => {
  const id = Math.abs(parseInt(communityId, 10)) || 0;
  return PALETTE[id % PALETTE.length];
};
